/** App-level state words (web, mobile, API). Utah's live in ut/app.ts; another state fills the same slots. */
import { APP_UT } from "./ut/app.ts";
import { perStateTable } from "./access.ts";
import type { StateWords, UsState } from "./types.ts";
import { wordsFor } from "./words.ts";

const WORDS: Record<UsState, StateWords<typeof APP_UT>> = perStateTable("APP", APP_UT);
/** The app phrases for a state (absent = Utah's, the default). */
export const appWords = (state?: string | null) => wordsFor(WORDS, state);
